module.exports = __webpack_public_path__ + "home/img/color-palette.1450110c.svg";